import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import './Home.css';
import BeginnersCoursePage from './BeginnersCoursePage';

// Register plugins
gsap.registerPlugin(ScrollTrigger);

const BegHome = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    // Initialize animations
    const initAnimations = () => {
      // Split text for animations
     

      // Image reveal animations
      const imageElements = document.querySelectorAll('[data-reveal="image"]');
      
      imageElements.forEach(element => {
        gsap.fromTo(element, 
          { 
            opacity: 0,
            scale: 1.1
          }, 
          { 
            opacity: 1,
            scale: 1,
            duration: 1.2,
            ease: "power3.out",
            scrollTrigger: {
              trigger: element,
              start: "top 85%",
              toggleActions: "play none none none"
            }
          }
        );
      });
    };

    // Run animations after a short delay to ensure DOM is fully loaded
    const timer = setTimeout(() => {
      initAnimations();
    }, 500);

    return () => {
      clearTimeout(timer);
      // Clean up ScrollTrigger instances to prevent memory leaks
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, []);

  return (
    <div className="home" ref={containerRef}>
      {/* <HeroSection />
      <ChallengeSection />
      <IntroSection />
      <PillarsSection />
      <Testimonial/>
      <BlackSection /> */}
     <BeginnersCoursePage/>
    </div>
  );
};

export default BegHome;